import { CommonInstallationsInfoDTO, ElevatorPresentStatus } from "shared/types/common-installations";


export const calculateElevatorDotValues = (commonInstallationsInfo: CommonInstallationsInfoDTO) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    if (commonInstallationsInfo.elevatorInspectionCertificateFileLogId) {
        dotValues.green.count++;
        dotValues.green.labels.push("Lift keuringsattest aanwezig");
    } else if (commonInstallationsInfo.elevatorPresentStatus == ElevatorPresentStatus.HAS_ELEVATOR && !commonInstallationsInfo.elevatorInspectionCertificateFileLogId) {
        dotValues.red.count++;
        dotValues.red.labels.push("Lift keuringsattest niet aanwezig");
    }

    if (commonInstallationsInfo.elevatorMaintenanceContractFileLogId) {
        dotValues.green.count++;
        dotValues.green.labels.push("Lift onderhoudscontract aanwezig");
    } else if (commonInstallationsInfo.elevatorPresentStatus == ElevatorPresentStatus.HAS_ELEVATOR && !commonInstallationsInfo.elevatorMaintenanceContractFileLogId) {
        dotValues.red.count++;
        dotValues.red.labels.push("Lift onderhoudscontract niet aanwezig");
    } else if(commonInstallationsInfo.elevatorPresentStatus != ElevatorPresentStatus.NO_ELEVATOR) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Lift onderhoudscontract na te kijken");
    }

    if (commonInstallationsInfo.elevatorRiskAnalysisFileLogId) {
        dotValues.green.count++;
        dotValues.green.labels.push("Lift risico-analyse aanwezig");
    } else if (commonInstallationsInfo.elevatorPresentStatus == ElevatorPresentStatus.HAS_ELEVATOR && !commonInstallationsInfo.elevatorRiskAnalysisFileLogId) {
        dotValues.red.count++;
        dotValues.red.labels.push("Lift risico-analyse niet aanwezig");
    } else if(commonInstallationsInfo.elevatorPresentStatus != ElevatorPresentStatus.NO_ELEVATOR) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Lift risico-analyse na te kijken");
    }

    if (commonInstallationsInfo.elevatorPresentStatus == ElevatorPresentStatus.HAS_ELEVATOR) {
        dotValues.green.count++;
        dotValues.green.labels.push("Lift aanwezig");
    } else if (commonInstallationsInfo.elevatorPresentStatus == ElevatorPresentStatus.NO_ELEVATOR) {
        dotValues.green.count++;
        dotValues.green.labels.push("Geen lift aanwezig");
    } else if (commonInstallationsInfo.elevatorPresentStatus == ElevatorPresentStatus.HAS_ELEVATOR_OUT_SERVICE) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Lift aanwezig maar buiten dienst");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Onbekend of lift aanwezig is");
    }

    // Custom Logic for Dates
    checkAndAddDateStatus(dotValues, commonInstallationsInfo, commonInstallationsInfo.elevatorContractTerminationDate, "Onderhoudscontract opzegdatum");
    checkAndAddDateStatus(dotValues, commonInstallationsInfo, commonInstallationsInfo.nextElevatorMaintenanceDate, "Inspectiedatum");

    return dotValues;
};

const checkAndAddDateStatus = (dotValues: any, commonInstallationsInfo: any, dateString: any, label: any) => {
    if(commonInstallationsInfo.elevatorPresentStatus == ElevatorPresentStatus.NO_ELEVATOR) return;
    
    if (!dateString) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push(`${label} onbekend`);
        return;
    }

    const currentDate = new Date();
    const targetDate = new Date(dateString);
    const fourMonthsBeforeTarget = new Date(targetDate);
    fourMonthsBeforeTarget.setMonth(targetDate.getMonth() - 4);

    if (currentDate > targetDate) {
        // Current date is past the target date
        dotValues.red.count++;
        dotValues.red.labels.push(`${label} vervallen`);
    } else if (currentDate >= fourMonthsBeforeTarget && currentDate <= targetDate) {
        // Current date is within four months before the target date
        dotValues.orange.count++;
        dotValues.orange.labels.push(`${label} komt er aan`);
    } else if (currentDate < fourMonthsBeforeTarget) {
        // Current date is more than four months before the target date
        dotValues.green.count++;
        dotValues.green.labels.push(`${label} nog binnen termijn`);
    } else if (commonInstallationsInfo.elevatorPresentStatus != ElevatorPresentStatus.NO_ELEVATOR) {
        console.log(commonInstallationsInfo.elevatorPresentStatus)
        // In case of any other unexpected situation
        dotValues.transparent.count++;
        dotValues.transparent.labels.push(`${label} onbekend`);
    }
};

